import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { notAuthGuard } from './core/guards/not-auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home-page/home-page').then(m => m.HomePage),
    data: { breadcrumb: 'Acasa' },
  },
  {
    path: 'cauta-firme',
    loadComponent: () => import('./features/search/search-page/search-page').then(m => m.SearchPage),
    data: { breadcrumb: 'Cauta Firme' },
  },
  {
    path: 'companie/:cui/:slug',
    loadComponent: () => import('./features/company/company-page/company-page').then(m => m.CompanyPage),
    data: { breadcrumb: 'Companie' },
  },
  {
    path: 'top-firme',
    loadChildren: () => import('./features/top/top.routes').then(m => m.TOP_ROUTES),
    data: { breadcrumb: 'Top Firme' },
  },
  {
    path: 'firme-nou-infiintate',
    loadComponent: () => import('./features/new-companies/new-companies-page/new-companies-page').then(m => m.NewCompaniesPage),
    data: { breadcrumb: 'Firme Nou Infiintate' },
  },
  {
    path: 'coduri-caen',
    loadChildren: () => import('./features/caen/caen.routes').then(m => m.CAEN_ROUTES),
    data: { breadcrumb: 'Coduri CAEN' },
  },
  {
    path: 'nomenclatoare',
    loadChildren: () => import('./features/nomenclatoare/nomenclatoare.routes').then(m => m.NOMENCLATOARE_ROUTES),
    data: { breadcrumb: 'Nomenclatoare' },
  },
  {
    path: 'comparatie',
    loadComponent: () => import('./features/comparison/comparison-page/comparison-page').then(m => m.ComparisonPage),
    data: { breadcrumb: 'Comparatie Firme' },
  },
  {
    path: 'harta-firme',
    loadComponent: () => import('./features/map/map-page/map-page').then(m => m.MapPage),
    data: { breadcrumb: 'Harta Firme' },
  },
  {
    path: 'autentificare',
    loadComponent: () => import('./features/auth/login-page/login-page').then(m => m.LoginPage),
    canActivate: [notAuthGuard],
    data: { breadcrumb: 'Autentificare' },
  },
  {
    path: 'inregistrare',
    loadComponent: () => import('./features/auth/register-page/register-page').then(m => m.RegisterPage),
    canActivate: [notAuthGuard],
    data: { breadcrumb: 'Inregistrare' },
  },
  {
    path: 'activate-account/:code',
    loadComponent: () => import('./features/auth/activate-account-page/activate-account-page').then(m => m.ActivateAccountPage),
    canActivate: [notAuthGuard],
    data: { breadcrumb: 'Activeaza Cont' },
  },
  {
    path: 'activate-account',
    loadComponent: () => import('./features/auth/activate-account-page/activate-account-page').then(m => m.ActivateAccountPage),
    canActivate: [notAuthGuard],
    data: { breadcrumb: 'Activeaza Cont' },
  },
  {
    path: 'profil',
    loadComponent: () => import('./features/auth/profile-page/profile-page').then(m => m.ProfilePage),
    canActivate: [authGuard],
    data: { breadcrumb: 'Profil' },
  },
  {
    path: 'export-firme',
    loadComponent: () => import('./features/bulk-export/bulk-export-page/bulk-export-page').then(m => m.BulkExportPage),
    canActivate: [authGuard],
    data: { breadcrumb: 'Export Firme' },
  },
  {
    path: 'export-firme/rapoarte',
    loadComponent: () => import('./features/bulk-export/bulk-export-rapoarte-page/bulk-export-rapoarte-page').then(m => m.BulkExportRapoartePage),
    canActivate: [authGuard],
    data: { breadcrumb: 'Rapoartele mele' },
  },
  {
    path: 'export-firme/:jobId',
    loadComponent: () => import('./features/bulk-export/bulk-export-job-page/bulk-export-job-page').then(m => m.BulkExportJobPage),
    canActivate: [authGuard],
    data: { breadcrumb: 'Raport export' },
  },
  {
    path: 'billing/checkout/:orderId',
    loadComponent: () => import('./features/billing/checkout-page/checkout-page').then(m => m.CheckoutPage),
    canActivate: [authGuard],
    data: { breadcrumb: 'Finalizare plată' },
  },
  {
    path: 'billing/result',
    loadComponent: () => import('./features/billing/billing-result-page/billing-result-page').then(m => m.BillingResultPage),
    canActivate: [authGuard],
    data: { breadcrumb: 'Plată' },
  },
  {
    path: 'despre',
    loadComponent: () => import('./features/static/about-page/about-page').then(m => m.AboutPage),
    data: { breadcrumb: 'Despre Noi' },
  },
  {
    path: 'surse-date',
    loadComponent: () => import('./features/static/data-sources-page/data-sources-page').then(m => m.DataSourcesPage),
    data: { breadcrumb: 'Surse de Date' },
  },
  {
    path: 'termeni-si-conditii',
    loadComponent: () => import('./features/static/terms-page/terms-page').then(m => m.TermsPage),
    data: { breadcrumb: 'Termeni si Conditii' },
  },
  {
    path: 'politica-confidentialitate',
    loadComponent: () => import('./features/static/privacy-page/privacy-page').then(m => m.PrivacyPage),
    data: { breadcrumb: 'Politica de Confidentialitate' },
  },
  {
    path: 'contact',
    loadComponent: () => import('./features/static/contact-page/contact-page').then(m => m.ContactPage),
    data: { breadcrumb: 'Contact' },
  },
  {
    path: 'politica-cookie',
    loadComponent: () => import('./features/static/cookie-policy-page/cookie-policy-page').then(m => m.CookiePolicyPage),
    data: { breadcrumb: 'Politica Cookie' },
  },
  {
    path: 'politica-livrare',
    loadComponent: () => import('./features/static/delivery-policy-page/delivery-policy-page').then(m => m.DeliveryPolicyPage),
    data: { breadcrumb: 'Politica de Livrare' },
  },
  {
    path: 'politica-anulare',
    loadComponent: () => import('./features/static/cancellation-policy-page/cancellation-policy-page').then(m => m.CancellationPolicyPage),
    data: { breadcrumb: 'Politica de Anulare' },
  },
  {
    path: 'politica-gdpr',
    loadComponent: () => import('./features/static/gdpr-page/gdpr-page').then(m => m.GdprPage),
    data: { breadcrumb: 'Politica GDPR' },
  },
  {
    path: '**',
    loadComponent: () => import('./features/static/not-found-page/not-found-page').then(m => m.NotFoundPage),
  },
];
